<template lang="pug">
div
  h3.capitalize Rodapp

  .input-container.arrow
    select.select(v-model="company" autocomplete="ño" required)
      option(value="sahet") Sahet
      option(value="bassica") Bássica
    label.label(:class="{ show: company }") Empresa

  .input-container
    input.input(v-model="order" @keyup.enter="getDataOrder" type="text")
    label.label(:class="{ show: order }") Introduce el número de orden

  button.button.button-shadow.capitalize.bg-principal(@click="getDataOrder") Traer Datos

  h3.capitalize Datos
  .table
    table
      thead
        tr.dark
          td Código Cliente
          td Nombre Cliente
          td Número Documento
          td Código Ciudad
          td Teléfono
          td Dirección
          td Complemento Dirección
          td Dinero a Cobrar
          td Contanido Paquete
          td Comentarios
      tbody
        tr(v-for="(order, index) in orders")
          td(@click="deleteOrder(index)") {{ order.company === 'sahet' ? '' : 'B'}}{{ order.order }}
          td.capitalize {{ order.name }}
          td
          td {{ order.location === 'bogota' ? '1' :  order.location === 'soacha' ? '6' : '' }}
          td {{ order.phones[0] }}
          td {{ order.address }}
          td {{ order.community || ''}}
          td {{ order.methodPay === 'cod' ? order.total : '0' }}
          td {{ order.company === 'sahet' ? 'ropa' : 'joyería acero'}}
          td
</template>

<script>
import mFilters from '@/mixins/filters'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import modals from '@my/store/modals'

export default {
  name: 'Welivery',

  mixins: [mFilters],

  props: {
    change: Object
  },

  data () {
    return {
      order: '',
      orders: [],
      company: ''
    }
  },

  methods: {
    async getDataOrder () {
      if (!this.order || !this.company) return

      const query = gqlOrder.GET_ALL
      const variables = { search: this.order, searchBy: 'order', limit: 1, page: 1, sort: 'createdAt', order: '-' }

      const response = await gql.query(query, variables, true, this.company === 'sahet')
      const docs = response.data.getOrders.docs

      if (!docs.length) {
        modals.showMessage({ message: `No se encontró la orden ${this.order}` })
      } else {
        const orderFound = docs[0]
        const indexOrder = this.orders.findIndex(order => order.order === orderFound.order && order.company === this.company)

        if (indexOrder >= 0) {
          this.orders[indexOrder] = orderFound
          return
        }

        orderFound.company = this.company

        this.orders.push(orderFound)
        this.order = ''
      }
    },

    deleteOrder (index) {
      this.orders.splice(index, 1)
    }
  }
}
</script>

<style lang="stylus">
.table
  overflow scroll
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Rodapp.vue